import React from "react";

import styles from "./styles.module.scss";
import { FormAreas } from "../components/FormAreas";
import { useSyncActive } from "../../../../utils/useSyncActive";

export const CreateAreas: React.FC = () => {
  const isSyncActive = useSyncActive();

  return (
    <>
      <div className={styles.createCustomers}>
        <FormAreas pageType="create" isSyncActive={isSyncActive} />
      </div>
    </>
  );
};
